"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Cell = _interopRequireDefault(require("./Cell"));

/* eslint-disable react/prop-types */
var Table = _styledComponents["default"].table.withConfig({
  displayName: "DataTable__Table",
  componentId: "sc-cznrtj-0"
})(["border-collapse:separate;border-spacing:0;width:100%;min-width:", "px;margin:auto;color:", ";tr th,tr td{padding:", "px 0px;font-size:14px;text-align:center;}tr td{border-bottom:1px solid ", ";}tr td:first-child{border-left:1px solid ", ";}tr td:last-child{border-right:1px solid ", ";}tr th{font-weight:500;background:", ";}tr:first-child th:first-child{border-top-left-radius:6px;padding-left:10px;}tr:first-child th:last-child{border-top-right-radius:6px;padding-right:10px;}tr:last-child td:first-child{border-bottom-left-radius:6px;}tr:last-child td:last-child{border-bottom-right-radius:6px;}"], function (_ref) {
  var minWidth = _ref.minWidth;
  return minWidth;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.dark[2];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space[3];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.dark[5];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.dark[5];
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.dark[5];
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.dark[5];
});

var DataTable = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(DataTable, _React$Component);

  function DataTable() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.renderHeadingRow = _this.renderHeadingRow.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderRow = _this.renderRow.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  var _proto = DataTable.prototype;

  _proto.renderHeadingRow = function renderHeadingRow(_cell, cellIndex) {
    var headings = this.props.headings;
    return /*#__PURE__*/_react["default"].createElement(_Cell["default"], {
      key: "heading-" + cellIndex,
      content: headings[cellIndex],
      header: true
    });
  };

  _proto.renderRow = function renderRow(_row, rowIndex) {
    var rows = this.props.rows;
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: "row-" + rowIndex
    }, rows[rowIndex].map(function (_cell, cellIndex) {
      return /*#__PURE__*/_react["default"].createElement(_Cell["default"], {
        key: rowIndex.toString() + "-" + cellIndex.toString(),
        content: rows[rowIndex][cellIndex]
      });
    }));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        headings = _this$props.headings,
        rows = _this$props.rows;

    var tableHead = /*#__PURE__*/_react["default"].createElement("tr", {
      key: "head"
    }, headings.map(this.renderHeadingRow));

    var tableBody = rows.map(this.renderRow);
    return /*#__PURE__*/_react["default"].createElement(Table, null, /*#__PURE__*/_react["default"].createElement("thead", null, tableHead), /*#__PURE__*/_react["default"].createElement("tbody", null, tableBody));
  };

  return DataTable;
}(_react["default"].Component);

DataTable.defaultProps = {
  minWidth: 600
};
var _default = DataTable;
exports["default"] = _default;